import { registerComponent } from '@gig/magic-common';
import FaqHeaderComponent from './faq-header.vue.js';

var FaqHeader = registerComponent(FaqHeaderComponent);

export { FaqHeader };
